import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500">编辑精选高分影视，本周必看推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cardItems.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-bold bg-accent-500 text-white">
                  {item.score}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-400 mb-2">{item.category}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {cardItems.slice(4).map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-bold bg-accent-500 text-white">
                  {item.score}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-400 mb-2">{item.category}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}